import React, { useEffect } from "react"
import PropTypes from "prop-types"
// Styles
import { Container, NavButton } from "./TableFooter.styles"


const TableFooter = ({ pages, setPage, page, slice }) => {

    useEffect(() => {
        slice.length < 1 && page !== 1 && setPage(page - 1)
    }, [slice, page, setPage])

    return (
        <Container>
            {pages.map((item) => (
                <NavButton key={item} onClick={() => setPage(item)} color={page === item ? "secondary" : "primary"}>{item}</NavButton>
            ))}
        </Container>
    )
}

TableFooter.propTypes = {
    pages: PropTypes.arrayOf(PropTypes.number),
    setPage: PropTypes.func,
    page: PropTypes.number,
    slice: PropTypes.array
}


export default TableFooter
